var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerceNonConforme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.112 20.5203C69.6689 20.7356 70.1464 21.1076 70.4829 21.5883C70.8194 22.0691 70.9995 22.6364 71 23.2173V56.7825C70.9995 57.3634 70.8194 57.9308 70.4829 58.4115C70.1464 58.8922 69.6689 59.2642 69.112 59.4795L40.112 70.717C39.3969 70.9941 38.5991 70.9941 37.884 70.717L8.884 59.4795C8.32788 59.2636 7.85122 58.8914 7.51544 58.4107C7.17966 57.93 7.00014 57.3629 7 56.7825V23.2173C7.00014 22.6369 7.17966 22.0698 7.51544 21.5891C7.85122 21.1085 8.32788 20.7362 8.884 20.5203L36.772 9.71292L36.788 9.70904L37.884 9.28279C38.6003 9.00469 39.3997 9.00469 40.116 9.28279L41.212 9.70904L41.228 9.71292L69.112 20.5203ZM63.616 22.5624L39 32.1027L14.384 22.5624L11 23.876V25.426L37 35.501V66.1988L39 66.9738L41 66.1988V35.5049L67 25.4299V23.8799L63.616 22.5624Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1358 12.7C62.6019 8.99053 58.3805 6.04433 53.7202 4.03497C49.0599 2.0256 44.0549 0.993692 39 1.00003C18.0126 1.00003 1.00003 18.4603 1.00003 40C0.988233 50.211 4.89059 60.0171 11.8642 67.3M11.8642 67.3C15.3981 71.0095 19.6195 73.9557 24.2798 75.965C28.9401 77.9744 33.9451 79.0063 39 79C59.9874 79 77 61.5397 77 40C77.0108 29.7884 73.107 19.9823 66.132 12.7L11.8642 67.3Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerceNonConforme);
export default __webpack_public_path__ + "static/media/MerceNonConforme.ea85db518bd50517ed17c010e428bcae.svg";
export { ForwardRef as ReactComponent };